import axios from 'axios'
// import qs from 'qs'
import GlobalData from './global_data'
import Util from './util'
import loginHelper from './login_helper'
const BACKENDURL = '/device-manage-backend'
const ADMINPATH = '/admin'

const SERVICES = {
  device: { name: '设备' },
  role: { name: '角色管理' },
  device_warning_setting: { name: '报警设置' }
}

class LocalCache {
  constructor () {
    this.cache = {}
  }

  hash (text) {
    'use strict'

    var hash = 5381
    var index = text.length

    while (index) {
      hash = (hash * 33) ^ text.charCodeAt(--index)
    }

    return hash >>> 0
  }

  set (key, data, expire) {
    key = this.hash(key)
    this.cache[key] = [new Date().getTime() + expire * 1000, data]
    // console.log("设置缓存", key, this.cache[key])
  }

  get (key) {
    key = this.hash(key)
    let r = this.cache[key]
    if (r) {
      if (new Date().getTime() >= r[0]) {
        // console.log("缓存过期", key, r)
        delete this.cache[key]
        r = undefined
      } else {
        // console.log("命中缓存", key, r, "剩余时间", r[0] - new Date().getTime())
        return r[1]
      }
    }
    return undefined
  }
}

const GlobalCache = new LocalCache()

function clearGlobalCache () {
  GlobalCache.cache = {}
}

function getBackendUrl (url) {
  if (url.indexOf('/') === 0) return BACKENDURL + ADMINPATH + url
  else return BACKENDURL + ADMINPATH + '/' + url
}

/**
 * 拷贝对象
 * @param src 源数据
 * @param fields 要拷贝到哪些字段，undefined，则是全部
 * @param dest 拷贝至哪个目标对象，undefined，则创建一个
 * @returns {*}
 */
function copyObject (src, fields, dest) {
  dest = !dest ? {} : dest
  for (var n in src) {
    if (fields === undefined || fields.indexOf(n) > -1) {
      dest[n] = src[n]
    }
  }
  return dest
}

/**
 * 处理返回结果
 * @param callSource 调用源
 * @param resp axios返回结果
 * @returns {Promise<unknown>}
 */
function handleResponse (callSource, resp, loadName) {
  if (loadName) callSource[loadName] = true
  const r = new Promise(function (resolve, reject) {
    resp
      .then(res => {
        if (loadName) {
          setTimeout(() => {
            callSource[loadName] = false
          }, 1000)
        }
        if (res.status === 200) {
          // console.log(typeof (res.data))
          if (
            res.headers['content-type'] &&
            res.headers['content-type'].startsWith('image/')
          ) {
            resolve(res)
          } else if (res.data.success) {
            var data = res.data.data
            resolve(data)
          } else {
            if (res.config.responseType === 'blob') {
              // blob对象转换为json
              const r = new FileReader()
              r.onloadend = e => {
                const res = JSON.parse(e.target.result)
                callSource.$message({ message: res.message, type: 'error' })
                if (reject) reject(res)
              }
              r.readAsText(res.data, 'utf-8')
            } else {
              if (res.data.error_code === 'invalid_session') { // token过期，自动退出登录
                loginHelper.logout(callSource, 'invalid_session')
              }
              callSource.$message({
                message: res.data.message,
                type: 'error'
              })
              if (reject) reject(res.data.message)
            }
          }
        } else {
          callSource.$message({ message: res.message, type: 'error' })
          if (reject) reject(res.message)
        }
      })
      .catch(err => {
        if (loadName) callSource[loadName] = false
        callSource.$message({ message: err.toString().indexOf('Network Error') ? '网络出错了' : err, type: 'error' })
        if (reject) reject(err)
      })
  })
  return r
}

function getFormData (obj) {
  const data = new FormData()
  for (var n in obj) {
    data.append(n, obj[n])
  }
  return data
}

function get (callSource, url, cacheExpire, forceRefresh) {
  return new Promise((resolve, reject) => {
    if (!forceRefresh && cacheExpire > 0 && GlobalCache.cache) {
      const r = GlobalCache.get(url)
      if (r) {
        r.$is_cache = true
        // console.log('缓存获取成功', r)
        if (resolve) resolve(r)
        return
      }
    }
    handleResponse(callSource, axios.get(getBackendUrl(url)))
      .then(data => {
        if (cacheExpire > 0) GlobalCache.set(url, data, cacheExpire)
        if (resolve) resolve(data)
      })
      .catch(reason => {
        if (reject) reject(reason)
      })
  })
}

function getOne (callSource, url) {
  return new Promise((resolve, reject) => {
    handleResponse(callSource, axios.get(getBackendUrl(url)))
      .then(data => {
        resolve(data)
      })
      .catch(reason => {
        reject(reason)
      })
  })
}

function post (callSource, url, data, type, config, loadName, noFilter) {
  const _data = noFilter ? data : Util.filterObj(data)
  if (type && type === 'toJson') {
    data = JSON.stringify(_data)
  } else {
    data = getFormData(_data)
  }

  //   if (isCanStringify(data)) data = qs.stringify(data)

  return handleResponse(
    callSource,
    axios.post(getBackendUrl(url), data, config),
    loadName
  )
}

function postFile (callSource, url, data, config) {
  const _data = Util.filterObj(data)
  data = getFormData(_data)

  return new Promise((resolve, reject) => {
    axios.post(getBackendUrl(url), data, config).then(res => {
      if (res.status === 200) {
        if (res.data.error_code === 'invalid_session') { // token过期，自动退出登录
          loginHelper.logout(callSource, 'invalid_session')
          callSource.$message({
            message: res.data.message,
            type: 'error'
          })
          reject(res.data.message)
        } else {
          resolve(res.data)
        }
      } else {
        callSource.$message({ message: res.message, type: 'error' })
        reject(res.message)
      }
    }).catch(err => {
      callSource.$message({ message: err.toString().indexOf('Network Error') ? '网络出错了' : err, type: 'error' })
      reject(err)
    })
  })
}

/**
 * 初始化查询页面
 * @param callSource callSource 调用源，传入this
 * @param service 服务
 * @param initData 初始数据，会自动设置为callSource的属性
 * @returns {{filter: string, records: *, tableData: *}}
 */
function initListPage (callSource, service, initData, filter, key) {
  callSource.service = service

  if (!initData.route_name) {
    initData.route_name = SERVICES[service].name + '列表'
  }
  let shareData = GlobalData.tabShareData[initData.route_name]
  const params =
    shareData !== undefined
      ? shareData.params
      : initData.params
        ? initData.params
        : {}
  if (params.max_results === undefined) params.max_results = 10
  if (!shareData) {
    shareData = initData.share ? initData.share : {}
    shareData.params = params
    shareData.pageData = {
      items: [],
      page: 1,
      filter: filter || '',
      first: -1,
      max_results: params.max_results,
      total: 0
    }
    if (key) callSource.$set(shareData.pageData, key, null)
    GlobalData.tabShareData[initData.route_name] = shareData
    if (!initData.init_not_load) queryList(callSource, shareData.pageData.filter, 0, params, undefined, key)
  } else if (shareData.refresh) {
    delete shareData.refresh
    // console.log("refresh", params)
    queryList(callSource, shareData.pageData.filter, 0, params, undefined, key)
  }
  initData.share = shareData
  initData.params = params // 缓存参数 id 查询条件
  initData.pageData = shareData.pageData
  initData.cache = new LocalCache()
  // console.log('init_list_page', init_data, init_data.route_name, GlobalData.tabShareData[init_data.route_name])
  return initData
}

function initListPageNoCache (callSource, service, initData, filter, key, cacheExpire) {
  callSource.service = service

  const params = initData.params
    ? initData.params
    : {}

  if (params.max_results === undefined) params.max_results = 10

  const pageData = {
    items: [],
    page: 1,
    filter: filter || '',
    first: -1,
    max_results: params.max_results,
    total: 0
  }
  queryList(callSource, pageData.filter, 0, params, cacheExpire, key)

  initData.pageData = pageData

  GlobalData.tabShareData[initData.route_name] = initData

  return initData
}

/**
 * 查询
 * @param callSource 调用源页面对象，传入this
 * @param filter 过滤字串
 * @param page 第几页
 */
function queryList (callSource, filter, page, params, cacheExpire, key) {
  let count
  let ps = ''
  if (params === undefined && callSource.share) { params = callSource.share.params }
  if (params !== undefined) {
    for (const n in params) {
      if (n === 'max_results') count = params.max_results
      else if (params[n] !== undefined && params[n] !== '' && params[n] !== null) {
        ps += '/' + n + '/' + params[n]
      }
    }
  }
  if (count === undefined) count = callSource.pageData.max_results
  if (count === undefined) count = 10
  const first = page <= 0 ? -1 : (page - 1) * count

  const base_url = `${callSource.service}/cmd/query/first/${first}/max_results/${count}${ps}`
  const url = `${base_url}/filter/${filter}`

  return new Promise(resolve => {
    get(callSource, url, cacheExpire === undefined ? 10 : cacheExpire)
      .then(data => {
        const pageData = callSource.pageData
        pageData.page = page
        pageData.filter = filter
        pageData.first = first
        pageData.max_results = count
        pageData.items = data.items
        if (key) pageData[key] = data[key]
        if (page <= 0 && data.count !== undefined) {
          pageData.total = data.count
        }
        resolve(data)
      })
  })
}

/**
 *
 * @param callSource 调用源页面对象，传入this
 * @param filter 过滤字串
 * @param page 第几页
 */
function findById (callSource, id, service, extParams, idName, cacheExpire) {
  if (service === undefined) service = callSource.service
  if (extParams === undefined) extParams = ''
  const url = service + '/' + (idName || 'id') + '/' + id + extParams
  return get(callSource, url, cacheExpire === undefined ? 10 : cacheExpire)
}

/**
 * 插入
 * @param callSource 调用源，传入this
 * @param row 要插入的行
 * @param fields 要插入哪些字段，不填写则全部字段
 * @param preData 预设数据
 */
function insertRow (callSource, row, fields, routerName) {
  return new Promise(resolve => {
    const service = callSource.service
    var sname = routerName || SERVICES[service].name
    handleResponse(
      callSource,
      axios.put(
        getBackendUrl(callSource.service),
        getFormData(copyObject(row, fields, undefined))
      )
    ).then(data => {
      if (resolve) resolve(data)
      callSource.$message.success('添加成功!')
      callSource.$emit('tableCloseDialog')
      const pageData = GlobalData.tabShareData[sname + '列表'].pageData
      if (pageData) {
        pageData.items.unshift(data)
        pageData.total += 1
      }
    })
  })
}

/**
 * 编辑
 * @param callSource 调用源，传入this
 * @param row 要插入的行
 * @param fields 要插入哪些字段，不填写则全部字段
 */
function editRow (callSource, row, fields, routerName) {
  return new Promise(resolve => {
    const service = callSource.service
    var sname = routerName || SERVICES[service].name
    handleResponse(
      callSource,
      axios.patch(
        getBackendUrl(callSource.service),
        getFormData(copyObject(row, fields))
      )
    ).then(data => {
      if (resolve) resolve(data)
      callSource.$message.success('修改成功!')
      callSource.$emit('tableCloseDialog')
      // 更新数据
      const pageData = GlobalData.tabShareData[sname + '列表'].pageData
      if (pageData) {
        const src = pageData.items.find(it => it[callSource.id_name] === row[callSource.id_name])
        copyObject(data, fields, src)
      }
    })
  })
}

function patch (callSource, service, row) {
  return handleResponse(
    callSource,
    axios.patch(
      getBackendUrl(service),
      getFormData(copyObject(row))
    )
  )
}
function put (callSource, service, row) {
  return handleResponse(
    callSource,
    axios.put(
      getBackendUrl(service),
      getFormData(copyObject(row))
      // qs.stringify(copyObject(row, fields))
    )
  )
}
/**
 * 删除行
 * @param callSource 调用源，传入this
 * @param rows 当前表数据的行数据
 * @param index 要删除行索引
 */
function deleteRow (callSource, row, routerName) {
  var sname = routerName || SERVICES[callSource.service].name

  return new Promise(resolve => {
    callSource
      .$confirm('数据删除后不可恢复，是否继续?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
      .then(() => {
        handleResponse(
          callSource,
          axios.delete(
            getBackendUrl(
              callSource.service + '/id/' + row[callSource.id_name]
            )
          )
        ).then(() => {
          callSource.$message.success('删除成功!')
          const pageData = GlobalData.tabShareData[sname + '列表'].pageData
          if (pageData) {
            const i = pageData.items.findIndex(it => it[callSource.id_name] === row[callSource.id_name])
            pageData.items.splice(i, 1)
            pageData.total -= 1
          }
          if (resolve) resolve()
        })
      })
  })
}

// 查询字典
function filterKeyValueList (callSource, key, customParam, filter, addAll, addEmpty, noCache) {
  return new Promise(resolve => {
    const _key = Array.isArray(key) ? key[0] : key
    const service = Array.isArray(key) ? key[1] : key

    const keyField = _key + '_name'
    const valueField = _key + '_id'
    const varName = _key

    const url =
      '/' +
      service +
      '/cmd/list/key_field/' +
      keyField +
      '/value_field/' +
      valueField +
      (customParam || '') +
      '/max_results/1000/text/'

    callSource[varName + '_loading'] = true
    if (filter === undefined) filter = ''

    setTimeout(() => {
      get(callSource, url + filter, 30, noCache)
        .then(data => {
          callSource[varName + '_loading'] = false
          if (addEmpty) {
            Util.addFirstKeyValueList(data.items, { value: '', text: '无' })
          }
          if (addAll) {
            Util.addFirstKeyValueList(data.items, { value: '', text: '全部' })
          }
          callSource.share[varName + 'List'] = data.items
          if (resolve) {
            resolve(data.items)
          }
        })
        .catch(e => {
          callSource[varName + '_loading'] = false
        })
    }, 10)
  })
}

export default {
  BACKENDURL,
  post,
  put,
  patch,
  get,
  getOne,
  findById,
  copyObject,
  GlobalCache,
  clearGlobalCache,
  initListPage,
  initListPageNoCache,
  queryList,
  insertRow,
  editRow,
  deleteRow,
  postFile,
  filterKeyValueList
}
